import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions
} from "@material-ui/core";
import moment from "moment";

interface ISentNotificationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  notifications: Array<{
    title: string;
    body: string;
    sentAt: Date;
  }>;
}

export const SentNotificationsModal: React.FC<ISentNotificationsModalProps> = ({
  isOpen,
  onClose,
  notifications
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Sent Notifications</DialogTitle>
      <DialogContent>
        {notifications.map((notification, index) => (
          <div key={index} style={{ marginBottom: 16, borderBottom: '1px solid #eee', paddingBottom: 16 }}>
            <Typography variant="h6" style={{ fontWeight: 'bold' }}>
              {notification.title}
            </Typography>
            <Typography variant="body1" style={{ marginTop: 8 }}>
              {notification.body}
            </Typography>
            <Typography variant="caption" color="textSecondary" style={{ marginTop: 8 }}>
              Sent: {moment(notification.sentAt).format('MMMM Do, YYYY h:mm:ss a')}
            </Typography>
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

